"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.benefits.precise_interactions': '精确快速地解决客户互动，确保高质量和效率。',
    'onboarding.benefits.customer_satisfaction': '通过改进的即时服务最大化客户满意度指标。',
    'onboarding.benefits.workflow_automation': '全面自动化关键工作流程，显著降低运营成本并释放人力资源。',
    'onboarding.benefits.real_time_insights': '有效利用实时数据生成深度洞察并推动可持续业务增长。',
};
